// src/emotionCache.ts
import createCache from '@emotion/cache';

// Read the CSP nonce from a meta tag in index.html
const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');

const emotionCache = createCache({
  key: 'css',
  nonce: nonce || undefined,
});

export default emotionCache;
